/* @ngInject */

export default (dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanApplicationLodgeHistory(
    id,
    idAccount,
    idLender,
    applicationId,
    idWorkflow,
    event,
    timeStamp
  ) {
    this.id = id;
    this.idAccount = idAccount;
    this.idLender = idLender;
    this.applicationId = applicationId;
    this.idWorkflow = idWorkflow;
    this.event = event;
    this.timeStamp = timeStamp;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanApplicationLodgeHistory.Blank = function () {
    return HomeLoanApplicationLodgeHistory.Build({
      id: _.uuid(),
      idAccount: '',
      idLender: '',
      applicationId: '',
      idStage: '',
      idWorkflow: '',
      event: '',
      timeStamp: dateTimeService.epoch()
    });
  };
  HomeLoanApplicationLodgeHistory.Build = function (data) {
    return new HomeLoanApplicationLodgeHistory(
      data.id ? data.id : _.uuid(),
      data.idAccount ? data.idAccount : '',
      data.idLender ? data.idLender : '',
      data.applicationId ? data.applicationId : '',
      data.idWorkflow ? data.idWorkflow : '',
      data.event ? data.event : '',
      data.timeStamp ? data.timeStamp : dateTimeService.epoch()
    );
  };

  return HomeLoanApplicationLodgeHistory;
};
